// extracted by mini-css-extract-plugin
export default {"headerButtonWrapper":"job-page_headerButtonWrapper__N5yTJ"};